import React from "react";
import { useDispatch } from "react-redux";
import parse from "html-react-parser";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { isMobile } from "react-device-detect";
import StarIcon from "../../../styles/img/svg/StarIcon";
import WeekLeftIcon from "../../../styles/img/svg/WeekLeftIcon";
import EndsTodayIcon from "../../../styles/img/svg/EndsTodayIcon";
import EventsEndedIcon from "../../../styles/img/svg/EventsEndedIcon";
import ActiveIcon from "../../../styles/img/svg/ActiveIcon";
import { UiButtonPrimary } from "../form/UiButton";
import { campaignStatuses, cardTypes } from "../../../_redux/_constants";
import { dateDiffWithToday } from "../../../_helpers/support.services";
import {
    campaignVoucherRemoveFromFavouriteRequest,
    campaignVoucherAddToFavouriteRequest,
} from "../../../_redux/_actions";
import FiveStarIcon from "../../../styles/img/svg/FiveStarIcon";
import FourStarIcon from "../../../styles/img/svg/FourStarIcon";
import ThreeStarIcon from "../../../styles/img/svg/ThreeStarIcon";
import TwoStarIcon from "../../../styles/img/svg/TwoStarIcon";
import AddtofavouritesIcon from "../../../styles/img/add-to-favourites.png";
import AddedtofavouritesIcon from "../../../styles/img/added-to-favourites.png";
import FiveStar from "../../../styles/img/svg/star-ratings/FiveStar";
import FourthStar from "../../../styles/img/svg/star-ratings/FourthStar";
import ThreeStar from "../../../styles/img/svg/star-ratings/ThreeStar";
import TwoStar from "../../../styles/img/svg/star-ratings/TwoStar";
import OneStar from "../../../styles/img/svg/star-ratings/OneStar";
import ZeroStar from "../../../styles/img/svg/star-ratings/ZeroStar";
import BuyIcon from "../../../styles/img/svg/BuyIcon"
import UiExperienceVideo from "./UiExperienceVideo";

export default function UiContentCard(props) {
    const actionDispatch = useDispatch();

    const navigate = useNavigate();

    const removeFromFavourites = (id, e) => {
        actionDispatch(
            campaignVoucherRemoveFromFavouriteRequest({
                id: id,
                from: props.showInContent,
            }),
        );
        e.stopPropagation();
    };

    const addToFavourites = (id, e) => {
        actionDispatch(
            campaignVoucherAddToFavouriteRequest({
                id: id,
                from: props.showInContent,
            }),
        );
        e.stopPropagation();
    };

    return (
        <>
            <div className={props.campaignClosed ? 'sb-content-card sb-content-card-closed':'sb-content-card'}>
                <div onClick={props.onClick} className="sb-content-card__inner">
                    <div className="sb-content-card__head">
                        {props.countDownStatus ==
                            campaignStatuses.CAMPAIGN_STATUS_COMING_SOON && (
                            <div className="sb-content-card__coming-soon">
                                <h5>Coming soon</h5>
                            </div>
                        )}
                        {props.countDownStatus ==
                            campaignStatuses.CAMPAIGN_STATUS_IS_ACTIVE && (
                            <div className="sb-content-card__active">
                                <h5>Active</h5>
                            </div>
                        )}
                        {props.countDownStatus ==
                            campaignStatuses.CAMPAIGN_STATUS_CLOSED && (
                            <div className="sb-content-card__closed">
                                <h5>Closed</h5>
                            </div>
                        )}
                        {props.cardImg ? (
                            <img src={props.cardImg} loading="lazy" />
                        ) : isMobile ? (
                            <UiExperienceVideo
                                width="100%"
                                video={props.video}
                            />
                        ) : (
                            <UiExperienceVideo
                                width="100%"
                                video={props.video}
                            />
                        )}

                        <div className="sb-content-card__ratings-wr">
                            <div className="sb-content-card__ratings-content-wr">
                                {props.timeStatus && (
                                    <div className="sb-content-card__time-status">
                                        {dateDiffWithToday(props.timeStatus) ==
                                            "7" && (
                                            <span className="sb-content-card__week-left">
                                                <WeekLeftIcon />1 Week Left
                                            </span>
                                        )}
                                        {dateDiffWithToday(props.timeStatus) ==
                                            "0" && (
                                            <span className="sb-content-card__end-today">
                                                <EndsTodayIcon />
                                                Ends Today
                                            </span>
                                        )}
                                        {dateDiffWithToday(props.timeStatus) <
                                            "0" && (
                                            <span className="sb-content-card__event-ended">
                                                <EventsEndedIcon />
                                                Event Ended
                                            </span>
                                        )}
                                        {dateDiffWithToday(props.timeStatus) !=
                                            "7" &&
                                            dateDiffWithToday(
                                                props.timeStatus,
                                            ) > "0" && (
                                                <span className="sb-content-card__active-card">
                                                    <ActiveIcon />
                                                    Active
                                                </span>
                                            )}
                                    </div>
                                )}

                                {props.msgStatus && (
                                    <span className="sb-content-card__msg-badge">
                                        {props.msgStatus}
                                    </span>
                                )}
                                <div className="sb-content-card__ratings-content">
                                    {/* {props.rating == 0 && props.rating && (
                                        <ZeroStar />
                                    )}
                                    {props.rating == 1  && props.rating && (
                                        <StarIcon />
                                    )}
                                    {props.rating == 2  && props.rating && (
                                        <TwoStarIcon />
                                    )}
                                    {props.rating == 3  && props.rating && (
                                        <ThreeStarIcon />
                                    )}
                                    {props.rating == 4 && props.rating && (
                                        <FourStarIcon />
                                    )}
                                    {props.rating == 5 && props.rating && (
                                        <FiveStarIcon />
                                    )} */}
                                    {/* <span> */}
                                    {/* {props.rating}{" "} */}
                                    {/* {(props.reviews) &&
                                            "(57" + props.reviews + "57)"} */}
                                    {/* </span> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {props.homeSlider && (
                        <>
                            <div className="sb-home-slider-wr">
                                {props.homeSlider && (
                                    <div className="sb-content-card__body">
                                        <div className="sb-content-card__banner-wr">
                                            <h4>{props.heading}</h4>
                                            <p>
                                                {parse(props.body)}
                                                {props.readMore && (
                                                    <span
                                                        onClick={props.readMore}
                                                    >
                                                        Read more ...
                                                    </span>
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                    {!props.homeSlider && (
                        <>
                            <div className="sb-content-card__body">
                                <div className="sb-content-card__body-top-area">
                                    <div className="sb-content-card__top-ratings-area">
                                        {props.rating == 0 && <ZeroStar />}
                                        {props.rating >= 1 &&
                                            props.rating < 2 && <OneStar />}
                                        {props.rating >= 2 &&
                                            props.rating < 3 && <TwoStar />}
                                        {props.rating >= 3 &&
                                            props.rating < 4 && <ThreeStar />}
                                        {props.rating >= 4 &&
                                            props.rating < 5 && <FourthStar />}
                                        {props.rating == 5 && <FiveStar />}

                                        <h3>
                                            {props.jobRole && (
                                                <div className="sb-job-role">
                                                    {props.jobRole}
                                                </div>
                                            )}
                                            {props.heading}{" "}
                                        </h3>
                                        {props.experincePoints && (
                                            <h4>
                                                {props.experincePoints} Points
                                            </h4>
                                        )}
                                    </div>

                                    {props.type != cardTypes.CAMPAIGN && (
                                        <div className="sb-favourite-icon">
                                            {props.isFavourite ? (
                                                <span
                                                    onClick={(e) =>
                                                        removeFromFavourites(
                                                            props.voucherId,
                                                            e,
                                                        )
                                                    }
                                                >
                                                    {" "}
                                                    <img
                                                        src={
                                                            AddedtofavouritesIcon
                                                        }
                                                    />{" "}
                                                </span>
                                            ) : (
                                                <span
                                                    onClick={(e) => {
                                                        addToFavourites(
                                                            props.voucherId,
                                                            e,
                                                        );
                                                    }}
                                                >
                                                    <img
                                                        src={
                                                            AddtofavouritesIcon
                                                        }
                                                    />{" "}
                                                </span>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {props.points != null && (
                                    <div className="sb-content-card__points-section">
                                        {props.points && (
                                            <div className="sb-content-card__points">
                                                <span>
                                                    {props.points} Points
                                                </span>
                                            </div>
                                        )}
                                        {props.savings && (
                                            <div className="sb-content-card__saving-points">
                                                <span>
                                                    Saving {props.savings}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                )}
                                {props.latestCampaign ? (
                                    <div className="sb-content-card__content-section">
                                        {parse(props.body.slice(0, 150))}

                                        {props.readMore && props.heading && (
                                            <span onClick={props.readMore}>
                                                Read more ...
                                            </span>
                                        )}
                                    </div>
                                ) : (
                                    <div className="sb-content-card__content-section-front">
                                        {parse(props.body.slice(0, 150))}

                                        {props.readMore && props.heading && (
                                            <span onClick={props.readMore}>
                                                Read more ...
                                            </span>
                                        )}
                                    </div>
                                )}
                            </div>

                            {props.learnMore && (
                                <div className="sb-content-card__bottom-btn">
                                    <UiButtonPrimary
                                        btnName="Learn more"
                                        size="30"
                                        onClick={props.learnMore}
                                    />
                                </div>
                            )}
                            {props.claimedAmount && (
                                <div className="sb-content-card__bottom-claimed">
                                    Claimed<span>{props.claimedAmount}</span>
                                    times
                                </div>
                            )}
                        </>
                    )}
                </div>
                {/* {props.addToCart && (
                    <div className="sb-content-card__footer">
                        <div
                                onClick={props.addToCart
                                    
                                }
                                className="sb-content-card__footer-right"
                            >
                                <BuyIcon />
                                
                            </div>
                    </div>
                )} */}
                {/* {props.footer && (
                    <div className="sb-content-card__footer">
                        {props.isFavourite ? (
                            <div
                                className="sb-content-card__footer-left favourite-remove"
                                onClick={() =>
                                    removeFromFavourites(props.voucherId)
                                }
                            >
                                <RemoveFavourites />
                                <h6>Remove from favourites</h6>
                            </div>
                        ) : (
                            <div
                                className="sb-content-card__footer-left"
                                onClick={props.addToFavourites}
                            >
                                <AddToFavourites />
                                <h6>Add to favourites</h6>
                            </div>
                        )}

                        <div
                            onClick={() =>
                                navigate("/app/shop/" + props.voucherId)
                            }
                            className="sb-content-card__footer-right"
                        >
                            <BuyIcon />
                            <h6>Buy</h6>
                        </div>
                    </div>
                )} */}
            </div>
        </>
    );
}

UiContentCard.propTypes = {
    cardImg: PropTypes.string,
    msgStatus: PropTypes.string,
    reviews: PropTypes.string,
    flashImage: PropTypes.string,
    flashText: PropTypes.string,
    timeStatus: PropTypes.string,
    heading: PropTypes.string,
    body: PropTypes.string,
    readMore: PropTypes.func,
    points: PropTypes.number,
    learnMore: PropTypes.func,
    bottomIcon: PropTypes.string,
    claimedAmount: PropTypes.number,
    isFavourite: PropTypes.bool,
};
